import { Component } from '@theme/component';
import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
import { morphSection, sectionRenderer } from '@theme/section-renderer';
import {
  ThemeEvents,
  CartUpdateEvent,
  QuantitySelectorUpdateEvent,
  CartAddEvent,
  DiscountUpdateEvent,
} from '@theme/events';
import { cartPerformance } from '@theme/performance';

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */
class CartItemsPackageComponent extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.#updatePackageCost();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  /**
   * Handles the cart update.
   *
   * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
   */
  #handleCartUpdate = (event) => {
    if (event instanceof DiscountUpdateEvent) {
      return;
    }
    if (event.target === this) return;

    this.#updatePackageCost();
  };

   /**
   * Update the cart with package cost
   */
  #updatePackageCost() {

    this.#toggleButton(true);

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        return response.json();
      }).then((cart) => {

        let items = cart.items;

        let filtered = items.filter((item) => item.product_type == 'Food' ).map((elem) => elem.quantity);

        let sum = filtered.reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          },0);

        let package_value = items.find((item) => item.variant_id == 56484985373054 );

        let package_qty = !package_value ? 0 : package_value.quantity;

        if(package_qty !== sum ) {
          let updates = {
              56484985373054 : sum,
            };

            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({updates})
            })
            .then(response => {

              this.dispatchEvent(
                new CartUpdateEvent({}, this.sectionId)
              );

              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              this.#toggleButton(false);
            });
        }else {
          this.#toggleButton(false);
        }
      }).catch(() => {
        this.#toggleButton(false);
      });
  }

  /**
   * Disabled / enable checkout button
   */
  #toggleButton(disabled) {
    const button = document.getElementById("checkout");
    console.log(button);
    if(disabled){
      button.setAttribute('disabled', '');
    }else {
      button.removeAttribute('disabled');
    }
    
  }

  /**
   * Gets the section id.
   * @returns {string} The section id.
   */
  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error('Section id missing');

    return sectionId;
  }
}

  customElements.define('cart-items-packages-component', CartItemsPackageComponent);

 /*
WHAT TO DO?

Add this to cart-products.liquid:
  <script
  src="{{ 'component-cart-package-cost.js' | asset_url }}"
  type="module"
  fetchpriority="low"
></script>

Add this to end of th stylesheet (with variant id) in cart-products.liquid:

tr[data-key^="56484985373054"] .quantity-selector{
    display: none;
  }

  tr[data-key^="56484985373054"] .cart-items__remove{
    display: none;
  }

wrap with this the main cart:

<cart-items-packages-component
class="cart-items-packages-component"
  data-section-id="{{ section.id }}">

  */